import {
  GET_METADATA,
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
  SET_PRODUCT_ID,
  SHOW_MESSAGE,
  GET_METADATA_INFO,
  SET_VISIBILITY,
} from "../../shared/constants/ActionTypes";

import jwtAxios from "@crema/services/auth/jwt-auth/jwt-api";

export const getMetaData = () => {
  return (dispatch, getState) => {
    const state = getState().metaData;
    dispatch({ type: FETCH_START });
    jwtAxios
      .get("/product/get", {
        params: { id: state.courseId },
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_METADATA,
            payload: data.data.data,
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response.data?.msg
            : error.message,
        });
      });
  };
};

export const editMetaData = (payload) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    return new Promise((resolve, reject) => {
      jwtAxios
        .put("/product/update-meta-data", payload)
        .then((data) => {
          if (data.status === 200) {
            dispatch({ type: FETCH_SUCCESS });
            dispatch({
              type: SHOW_MESSAGE,
              payload: "Metadata updated successfully",
            });
            dispatch({
              type: GET_METADATA,
              payload: { metaData: payload.metaData },
            });
            dispatch(getMetaDataInfo());
            resolve();
          } else {
            dispatch({
              type: FETCH_ERROR,
              payload: "Something went wrong, Please try again!",
            });
            reject();
          }
        })
        .catch((error) => {
          dispatch({
            type: FETCH_ERROR,
            payload: error.response?.data?.msg
              ? error.response?.data?.msg
              : error.message,
          });
          reject();
        });
    });
  };
};

export const featureMetaData = (payload) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/product/set-feature-flag", payload)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Metadata updated successfully",
          });
          dispatch(getMetaData());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const getMetaDataInfo = () => {
  return (dispatch, getState) => {
    const state = getState().metaData;
    dispatch({ type: FETCH_START });
    jwtAxios
      .get("/product/get-meta-data-info", {
        params: { id: state.courseId },
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_METADATA_INFO,
            payload: data.data.data,
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response.data?.msg
            : error.message,
        });
      });
  };
};

export const setCourseId = (courseId) => {
  return (dispatch) => {
    dispatch({ type: SET_PRODUCT_ID, payload: courseId });
  };
};

export const updateMetaDataInfo = (metadata) => {
  return (dispatch) => {
    dispatch({ type: SET_VISIBILITY, payload: metadata });
  };
};
